import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { infoReasons, sendTrackingRequest } from "./helper";
import img from "../../../assets/images/contact-image.png";
import listIcon from "../../../assets/images/list-indicator.png";
import "./styles.scss";
import { useForm } from "react-hook-form";
import { Spring } from "react-spring/renderprops";
import { useRouter } from "../../../util/router";

const CollectInformation = ({ setStep, roofData, setRoofData }) => {
  const { register, handleSubmit, errors } = useForm();
  const router = useRouter();

  const { pathname } = router;

  const submit = async (formData) => {
    await sendTrackingRequest(pathname);

    await setRoofData({
      ...roofData,
      ...formData,
    });
    return setStep(5);
  };

  return (
    <>
      <Spring
        from={{ opacity: 0 }}
        to={{ opacity: 1 }}
        config={{ duration: 1500 }}
      >
        {(props) => (
          <Container style={props} className="multi-form-step-section">
            <span>
              <div>
                <img
                  src={img}
                  className="toast-image mr-1"
                  alt="Helper Profile"
                />
              </div>
              <h5 className="heading-collect-data-form">
                {" "}
                Great, in the last step we need your contact information
              </h5>
            </span>
            <div>
              <div className="roof-selection-section-fullwidth">
                <Row>
                  <Col className="p-1 mb-5" md={6} sm={12} xs={12}>
                    <div className="collect-info-form-section">
                      <form onSubmit={handleSubmit(submit)}>
                        <Form.Group controlId="Full Name">
                          <Form.Label
                            className={errors.fullName ? "text-danger" : " "}
                          >
                            {errors.fullName
                              ? "This field is required"
                              : "Full Name"}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            ref={register({ required: true })}
                            name="fullName"
                            placeholder={"John Doe"}
                            defaultValue={roofData?.fullName}
                          />
                        </Form.Group>
                        <Form.Group controlId="Email">
                          <Form.Label
                            className={errors.email ? "text-danger" : " "}
                          >
                            {errors.email ? "This field is required" : "Email "}
                          </Form.Label>
                          <Form.Control
                            type="email"
                            ref={register({ required: true })}
                            name="email"
                            placeholder="johndoe@gmail.com"
                            defaultValue={roofData?.email}
                          />
                        </Form.Group>

                        <Form.Group controlId="Phone">
                          <Form.Label
                            className={errors.phoneNumber ? "text-danger" : " "}
                          >
                            {errors.phoneNumber
                              ? "This field is required"
                              : "Phone "}
                          </Form.Label>
                          <Form.Control
                            type="tel"
                            ref={register({ required: true })}
                            name="phoneNumber"
                            placeholder="+1 (800) 401-7716"
                            defaultValue={roofData?.phoneNumber}
                          />
                        </Form.Group>

                        <Button
                          className="btn-block mt-5 py-2"
                          variant={"success"}
                          type="submit"
                        >
                          Get Free Estimate!
                        </Button>
                      </form>
                    </div>
                  </Col>
                  <Col className="p-1 mb-5" md={6} sm={12} xs={12}>
                    <h6 className="reasons-header">
                      {" "}
                      Why we need your information?
                    </h6>
                    <ul className="reasons-ul">
                      {infoReasons.map((infoReason, i) => (
                        <li key={i}>
                          {" "}
                          <span>
                            <img
                              src={listIcon}
                              className="li-item-icon"
                              alt={"List Item icon"}
                            />{" "}
                          </span>
                          <span> {infoReason.reason}</span>
                        </li>
                      ))}
                    </ul>
                  </Col>
                </Row>
              </div>
            </div>
          </Container>
        )}
      </Spring>
    </>
  );
};

export default CollectInformation;
